// extracted by mini-css-extract-plugin
export default {"companySettingsWarning":"PunchhForm_companySettingsWarning__wFjJH","loading":"PunchhForm_loading__UGcGX"};